export enum CatchJobPlatform {
  CATCH_TALENTS_JOBBOARD_ID = 1,
  GOOGLE_JOB_POSTING_ID = 2,
  CATCH_TALENTS_ACTIVE_SOURCING_ID = 3,
  CATCH_TALENTS_ACTIVE_SOURCING_BOOSTER_ID = 4,
  SOURCED_JOBS_LEADS = 'sourced_jobs_leads',
  SOURCED_JOBS_AUTOPILOT = 'sourced_jobs_autopilot',
}
